import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import GatewayUrl from "../../components/Gateway/Gateway";
import { fetchOptions } from '../../hooks/fetchOptions'
export interface session {
    active: boolean;
    session: string;
    error: boolean;
    errorCode: string;
    noOfferTrigger: boolean;
    sessionInvalid: boolean;
}

const initialState: session = {
    active: false,
    session: '',
    error: false,
    errorCode: '',
    noOfferTrigger: false,
    sessionInvalid: false
}


export const sessionSlice = createSlice({
    name: 'session',
    initialState,
    reducers: {
        setActive: (state, action: PayloadAction<boolean>) => {
            state.active = action.payload
            state.sessionInvalid = false
        },

        setSession: (state, action: PayloadAction<string>) => {
            state.session = action.payload
        },

        setError: (state, action: PayloadAction<boolean>) => {
            state.error = action.payload
        },

        setErrorCode: (state, action: PayloadAction<string>) => {
            state.errorCode = action.payload
        },

        setNoOfferTrigger: (state, action: PayloadAction<boolean>) => {
            state.noOfferTrigger = action.payload
        },

        handleLoadingError: (state, action: PayloadAction<string>) => {
            let count: any = 0;
            const maxErrorCount: number = 10;

            if (sessionStorage.getItem('loadingError')) {
                count = sessionStorage.getItem('loadingError')
                count++;
                sessionStorage.setItem('loadingError', count)
            } else {
                sessionStorage.setItem('loadingError', '1')
            }

            if (count < maxErrorCount) {
                //window.location.reload();
            } else {
                const payload: object = {
                    method: "createErrorLog",
                    errorLogCode: action.payload,
                    userAgent: String(navigator.userAgent),
                }

                fetch(GatewayUrl, fetchOptions(payload));

                state.error = true;
                state.errorCode = action.payload;

                sessionStorage.removeItem('loadingError')
            }
        },

        setSessionInvalid: (state, action: PayloadAction<boolean>) => {
            state.sessionInvalid = action.payload
        },

        logoutUser: (state) => {
            localStorage.removeItem("sessionId");
            state.active = false
        },
    },
})

// Action creators are generated for each case reducer function
export const {
    setActive,
    setSession,
    setError,
    setErrorCode,
    setNoOfferTrigger,
    handleLoadingError,
    logoutUser,
    setSessionInvalid
} = sessionSlice.actions

export default sessionSlice.reducer